export default ({...props}) => {
  const {palette} = props.theme
  return `
      [ap_type="app_spinner"] {
        color: ${palette.primary.main};
      }
    `
}
